import Documents from "../components/Documents";
import WebApp from "../components/WebApp";

const DocumentsPage = () => {
  return (
    <WebApp>
      <Documents></Documents>
    </WebApp>
  );
};


export default DocumentsPage;